import React from "react";
import PaymentGateways from "repoV2/features/Payments/modules/PaymentGateways/PaymentGateways";
import useLazyLoadPaymentGateways from "repoV2/features/Payments/utils/useLazyLoadPaymentGateways";
import { PAYMENT_GATEWAY_RENDER_DELAY } from "repoV2/features/Payments/Payments.constants";
import useCheckoutPaymentGateways from "./useCheckoutPaymentGateways";

const CheckoutPaymentGateways = () => {
    const {
        isCheckoutPagePriceSectionApiDataLoading,
        paymentGatewayConfig,
        isListingLive,
    } = useCheckoutPaymentGateways();

    const shouldLoadPaymentGateways = useLazyLoadPaymentGateways(
        PAYMENT_GATEWAY_RENDER_DELAY
    );

    return (
        <>
            <PaymentGateways
                // We are going to load the payment gateways when one of
                // the two is true,
                // 1. Either user has made an interaction or has spent 30 seconds on the screen
                // 2. Checkout page price section api is not loading, and has provided the response,
                // we get the payment gateways to be loaded from this api
                // 3. If the listing is live, as no point of loading the gateways if the listing is
                // in draft, expired or sold out status, as there'll be no payment in these cases
                loadPaymentGateways={
                    shouldLoadPaymentGateways &&
                    !isCheckoutPagePriceSectionApiDataLoading &&
                    isListingLive
                }
                paymentGatewayConfig={paymentGatewayConfig}
            />
        </>
    );
};

export default CheckoutPaymentGateways;
